/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enum representing the type of integration.
 * @export
 */
export const IntegrationType = {
    Recruitee: 'Recruitee',
    Homerun: 'Homerun'
};
export function instanceOfIntegrationType(value) {
    for (const key in IntegrationType) {
        if (Object.prototype.hasOwnProperty.call(IntegrationType, key)) {
            if (IntegrationType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function IntegrationTypeFromJSON(json) {
    return IntegrationTypeFromJSONTyped(json, false);
}
export function IntegrationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function IntegrationTypeToJSON(value) {
    return value;
}
export function IntegrationTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
